import { atom, useSetRecoilState, useRecoilValue } from 'recoil';

/**
 * A state to determine messaging service state to show indicators to the users
 */
const messagingServiceStatus = atom({
  key: 'messagingServiceStatus',
  default: '',
});

export const useMessagingServiceStatusValue = () =>
  useRecoilValue(messagingServiceStatus);

export const useSetMessagingServiceStatus = () =>
  useSetRecoilState(messagingServiceStatus);
